import { createSlice } from "@reduxjs/toolkit";

interface EmployeePageInterface {
    currentPage: number;
    itemsPerPage: number;
    searchTerm: string;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    statusFilter?: { value: string; label: string; color: string };
    functionGroupFilter?: { value: string; label: string };
    sort: {
        sortName: string;
        isSorted: boolean;
    };
}

const initialState: EmployeePageInterface = {
    currentPage: 1,
    itemsPerPage: 12,
    searchTerm: "",
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    sort: {
        sortName: "last_name",
        isSorted: true,
    },
};

const employeeSlice = createSlice({
    name: "employee",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        setFunctionGroupFilter: (state, action) => {
            state.functionGroupFilter = action.payload;
        },
        setSort: (state, action) => {
            state.sort = action.payload;
        },
    },
});

export const employeeReducer = employeeSlice.reducer;

export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setStatusFilter,
    setFunctionGroupFilter,
    setSort,
} = employeeSlice.actions;
